module.exports = __webpack_public_path__ + "img/logoTuTaxi.f8d6ee74.png";